<template>
  <div class="content" v-if="!loading && scans">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:let;margin-top:5px;">Pedidos de Resgate de Clube Fidelidade</span>
    </div>
    
    <div class="line">
      <div style="padding:10px; ">

        <table border="1" cellpadding="5px" style="min-width:700px; border-collapse:collapse; border:1px solid #706C7A;width:100%">
          <thead>
            <tr>
              <td>Foto</td>
              <td style="width:100px;text-align:center;">Ações</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scan, idx) in scans" v-bind:key="idx">
              <td>
                <img @click="zoomImage(scan.img)" :src="scan.img" style="max-width:200px;max-height:250px;" />
              </td>
              <td style="text-align:center;">
                <a @click="openModalPoints(scan)">
                  <font-awesome-icon style="font-size:18px;color:#12FCC4;margin:5px 10px;"  :icon="['fal', 'pencil']"/>
                </a>
                <a @click="deleteImage(scan, true)">
                  <font-awesome-icon style="font-size:18px;color:#FF0000;margin:5px 10px;"  :icon="['fal', 'trash']"/>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


    <OpaModal v-if="tempPoints && scans" width="500" height="540" v-model="modalPoints" header="Detalhes do Resgate">
      <div style="height:380px;overflow:auto; padding:20px;width:100%">
        <div style="padding:10px;float:left;">
          ID do Usuário: {{tempPoints.user_id}}<br/><br/>
          Número da Nota:<br/>
          <input type="text" class="inputWire" style="border-color:#ffffff;width:360px;margin-bottom:10px;" v-model="tempPoints.nfe_number" />
          <br/>
          CPNJ:<br/>
          <input type="text" class="inputWire" style="border-color:#ffffff;width:360px;margin-bottom:10px;" v-model="tempPoints.cnpj" />
          <br/>
          Preço Consumido em Produtos {{$store.state.company.companyBrand}}:<br/>
          <input type="text" class="inputWire" style="border-color:#ffffff;width:360px;margin-bottom:10px;" v-model.number="tempPoints.total_price_eligible" />
          <br/>
        </div>
      </div>
      <div class="modal_footer">
        <button style="width:80px;float:right;margin:20px;" @click="savePoints(); modalPrizer=false">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;" @click="closeModalPoints();">Cancelar</button>
      </div>
    </OpaModal>


    <div v-if="zommModal" style="width:100vw;height:100vh;position:fixed;top:0;left:0;">
      <div style="width:100%;height:calc(100% - 90px);overflow:auto;background-color:#ffffff;position:relative">
        <img ref="tempImg" :src="tempImg" style="position:absolute;left:0;top:0;"/>
      </div>
      <div style="width:100%;height:90px;background-color:#c0c0c0;">
        <button @click="rotateLeft()" style="width:50px;margin:20px;">esq</button>
        <button @click="rotateRight()"  style="width:50px;margin:20px;">dir</button>
        <button @click="zommPlus()"  style="width:50px;margin:20px;">+</button>
        <button @click="zommMinus()"  style="width:50px;margin:20px;">-</button>
        <button @click="zommModal = false">Fechar</button>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script>
import OpaModal from '@/components/OpaModal.vue'
import { EventBus } from '@/utils/event-bus'
import MembershipConn from '@/connection/membership'
import formater from '@/mixins/formater'
import ImagesConn from '@/connection/Images'



export default {
  name: 'Banners',
  data () {
    return {
      scans: null,
      modalPoints: false,
      tempPoints: null,
      loading: true,
      zommModal: false,
      tempImg: null,
      tempRotation: 0,
      tempZoom: 1.0,
      tempPointsImage: null
    }
  },

  mixins: [formater],

  components: {OpaModal},
   
  created () {
    if (this.loading) {
      EventBus.$emit('showLoading', true)
    }
    this.resetTempPoints()
    this.loadScans()
  },

  methods: {

    async loadScans () {
      let result = await MembershipConn.getNfeList()
      if (result.error) {
        this.scans = []
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        this.scans = []
        result.forEach((image) => {
          this.scans.push(this.getImageToObject(image))
        })
      }
      this.loading = false
      EventBus.$emit('showLoading', false)
    },

    resetTempPoints () {
      this.tempPoints = {
        "nfe_number": null,
        "cnpj": null,
        "user_id": null,
        "total_price_eligible": 0
      }
    },

    openModalPoints (order) {
      this.resetTempPoints()
      this.tempPoints.user_id = order.user_id
      this.modalPoints = true
      this.tempPointsImage = order
      
    },

    closeModalPoints () {
      this.modalPoints = false
      this.resetTempPoints()
    },

    async savePoints () {
      EventBus.$emit('showLoading', true)
      let result = await MembershipConn.savePointsByNfe(this.tempPoints)
      EventBus.$emit('showLoading', false)
      if (!result.error) {
        this.closeModalPoints()
        this.deleteImage(this.tempPointsImage, false)
      } else {
        EventBus.$emit('showAlert', 'error', result.msg)
      }
    },

    async deleteImage (image, confirmMessage) {
      let doing = false
      if (confirmMessage && confirm('Deseja realmente excluir a nota?')){
        doing = true
      } else if (!confirmMessage) {
        doing = true
      }
      if (doing) {
        EventBus.$emit('showLoading', true)
        let result = await ImagesConn.deleteMembershipScanImage(image.data)
        EventBus.$emit('showLoading', false)
        if (result.error) {
          EventBus.$emit('showAlert', 'error', result.msg)
        } else {
          this.loadScans()
        }
      }
    },

    getImageToObject (image) {
      let data = image.split('/')
      let obj = {
        img: 'https://' + this.$store.state.company.Id + '/img/' + data[2] + '/' + data[3] + '/'+ data[4] + '/'+ data[5],
        user_id: data[4],
        data: image
      }
      return obj
    },

    zoomImage (img) {
      this.tempImg = img
      this.zommModal = true
      this.tempRotation = 0
      this.tempZoom = 1.0
      let imgO = this.$refs.tempImg
      if (imgO) {
        imgO.style.transform = "initial";
      }
    },

    rotateLeft () {
      let img = this.$refs.tempImg
      this.tempRotation = this.tempRotation - 90
      img.style.transform = "rotate(" + (this.tempRotation) + "deg) scale(" + (this.tempZoom) + ","+ (this.tempZoom) +")";
    },
    rotateRight () {
      let img = this.$refs.tempImg
      this.tempRotation = this.tempRotation + 90
      img.style.transform = "rotate(" + (this.tempRotation) + "deg) scale(" + (this.tempZoom) + ","+ (this.tempZoom) +")";
    },
    zommPlus () {
      let img = this.$refs.tempImg
      this.tempZoom = this.tempZoom + 0.1
      img.style.transform = "rotate(" + (this.tempRotation) + "deg) scale(" + (this.tempZoom) + ","+ (this.tempZoom) +")";
    },
    zommMinus () {
      console.log('zoom', "scale(" + (this.tempZoom) + ","+ (this.tempZoom) +");")
      let img = this.$refs.tempImg
      if (this.tempZoom > 0.2) {
        this.tempZoom = this.tempZoom - 0.1
      }
      img.style.transform = "rotate(" + (this.tempRotation) + "deg) scale(" + (this.tempZoom) + ","+ (this.tempZoom) +")";
    },

  }
}
</script>

<style> 
a {
  cursor:pointer;
}
</style>